module.exports = __webpack_public_path__ + "static/media/lista.b1382db6.svg";